<template>
  <el-table
    :data="dgData"
    style="width: 100%"
    size="small"
    striped
    border
  >
    <el-table-column
      prop="itemdg_prodclass"
      label="Product Class"
    />
    <el-table-column
      prop="itemdg_propname"
      label="Proper Name"
    />
    <el-table-column
      prop="itemdg_comname"
      label="Common Name"
    />
    <el-table-column
      prop="itemdg_hazclass"
      label="Hazard Class"
    />
    <el-table-column
      prop="itemdg_unno"
      label="UN Number"
    />
    <el-table-column
      prop="itemdg_hazcode"
      label="Hazard Code"
    />
    <el-table-column
      prop="itemdg_packgroup"
      label="Packaging Group"
    />
    <el-table-column
      prop="itemdg_flashpt"
      label="Flash Point"
    />
    <el-table-column
      prop="itemdg_addinfo"
      label="Additional Info"
    />
    <el-table-column
      prop="itemdg_marpol"
      label="Marine Pollutant"
    />
    <el-table-column
      prop="itemdg_packtype"
      label="Packaging Type"
    />
    <el-table-column
      prop="itemdg_subrisk"
      label="Sub Risk"
    />
    <el-table-column
      prop="itemdg_packinst"
      label="Pack Instructions"
    />
    <el-table-column
      prop="itemdg_apicode"
      label="API Code"
    />
    <el-table-column
      prop="description"
      label="Description"
    />
    <el-table-column
      prop="weight"
      label="Weight"
    />
  </el-table>
</template>
<script>
export default {
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      dgData: [{
        itemdg_prodclass: this.item.dg.itemdg_prodclass,
        itemdg_propname: this.item.dg.itemdg_propname,
        itemdg_comname: this.item.dg.itemdg_comname,
        itemdg_hazclass: this.item.dg.itemdg_hazclass,
        itemdg_unno: this.item.dg.itemdg_unno,
        itemdg_hazcode: this.item.dg.itemdg_hazcode,
        itemdg_packgroup: this.item.dg.itemdg_packgroup,
        itemdg_flashpt: this.item.dg.itemdg_flashpt,
        itemdg_addinfo: this.item.dg.itemdg_addinfo,
        itemdg_marpol: this.item.dg.itemdg_marpol,
        itemdg_packtype: this.item.dg.itemdg_packtype,
        itemdg_subrisk: this.item.dg.itemdg_subrisk,
        itemdg_packinst: this.item.dg.itemdg_packinst,
        itemdg_apicode: this.item.dg.itemdg_apicode,
        weight: this.item.itemdg_weight,
        description: this.item.itemdg_desc
      }]
    }
  }
}
</script>
